import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { ValueType } from 'react-select';
import { Button, Col, DropdownItem, Row } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { activateUsers, importCSV } from '../../../stores/users/actionCreators';
import FormInput from '../../common/FormInput';
import ConfirmModal from '../../common/modals/ConfirmModal';
import WorkspaceSelect from '../../workspaces/WorkspaceSelect';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;

    csvImport: (csv: string, emailUsers: boolean, workspaceId: string) => void;
}
interface State {
    showModal: boolean;
    csv: string;
    emailUsers: boolean;
    workspace?: { value: string, label: string };
}

const initialState = {
    csv: '',
    emailUsers: false,
    showModal: false,
    workspace: undefined,
};

class CSVImportAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = initialState;
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['ADD_USER', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <Button
                        onClick={(e) => {
                            this.setState({ ...initialState, showModal: true });

                        }}
                        className="mr-2"
                    >
                        <FontAwesomeIcon icon={['fal', 'download']} className="mr-4" />
                        {t('users.button.csvImport')}
                    </Button>
                    <ConfirmModal
                        header={t('users.modal.csvImport.header') as string}
                        confirmText={t('users.modal.csvImport.import') as string}
                        buttonColor="success"
                        isOpen={this.state.showModal}
                        big={true}
                        confirm={() => {
                            this.props.csvImport(
                                this.state.csv,
                                this.state.emailUsers,
                                this.state.workspace?.value ?? '');
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        <Row>
                            <Col md={6}>
                                <FormInput
                                    type="checkbox"
                                    name="emailUsers"
                                    checked={this.state.emailUsers}
                                    fullName={t('users.modal.csvImport.emailUsers') as string}
                                    onChange={this.handleInputChange}
                                />
                                <hr />
                                {t('users.modal.csvImport.workspace')}
                                <WorkspaceSelect
                                    selected={[]}
                                    updateSelection={this.handleSelectChange}
                                    selection={this.state.workspace}
                                />
                            </Col>
                            <Col md={6}>
                                Format: <code>email, first_name, last_name, application_path, group_name[]</code>
                                <br />
                                {t('users.modal.csvImport.text')}
                                <FormInput
                                    type="textarea"
                                    name="csv"
                                    value={this.state.csv}
                                    onChange={this.handleInputChange}
                                    style={{
                                        fontFamily: 'monospace',
                                        height: '300px',
                                        whiteSpace: 'pre',
                                    }}
                                />
                            </Col>
                        </Row>
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            [event.target.name]: event.target.type === 'checkbox' ?
                event.target.checked : event.target.value,
            // tslint:disable-next-line:no-any
        } as any);
    }

    private handleSelectChange = (val?: ValueType<{ label: string; value: string }>) => {
        // tslint:disable-next-line:no-any
        this.setState({ workspace: val as any });
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    csvImport: (csv: string, emailUsers: boolean, workspaceId: string) =>
        dispatch(importCSV(csv, emailUsers, workspaceId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(CSVImportAction));